// src/components/Capabilities/Capabilities.jsx
import React, { useEffect } from 'react';
import Navbar from '../Navbar/navbar'; // Correct path to Navbar
import Footer from '../Footer/Footer'; // Correct path to Footer
import './Capabilities.css';
import { Container, Row, Col } from 'react-bootstrap';

// Import Icons
import iconStamping from '../../assets/Capabilities/Press machine.png';
import iconTooling from '../../assets/Capabilities/Engineering.png';
import iconDie from '../../assets/Capabilities/Moulding box.png';
import iconWelding from '../../assets/Capabilities/Mechanical arm.png';
import iconMolding from '../../assets/Capabilities/Molding machine.png';
import iconCNC from '../../assets/Capabilities/Cnc machine.png';
import iconQuality from '../../assets/Capabilities/Technical drawing.png';
import iconOEM from '../../assets/Capabilities/Work list.png';
import iconISO from '../../assets/Capabilities/Quality control.png';

const Capabilities = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const capabilities = [
    { title: "Precision automotive metal stamping", icon: iconStamping },
    { title: "Tool design & development (in-house tool room)", icon: iconTooling },
    { title: "Progressive & transfer die manufacturing", icon: iconDie },
    { title: "Robotic welding", icon: iconWelding },
    { title: "Injection moulding", icon: iconMolding },
    { title: "CNC machining (VMC, wire cut, etc.)", icon: iconCNC },
    { title: "Vision inspection & quality testing", icon: iconQuality },
    { title: "OEM project support & new product development", icon: iconOEM },
    { title: "IATF / ISO quality systems", icon: iconISO }
  ];

  return (
    <div className="capabilities-page-wrapper">
      <Navbar />
        <section className="about-hero-section">
              <Container>
                <Row>
                  <Col lg={12}>
                    <div className="about-hero-content">
                      {/* Main Title: About (Regular) Us (Bold) */}
                      <h1 className="about-hero-title">
                        <span>Capabilities</span>
                      </h1>
                    </div>
                  </Col>
                </Row>
              </Container>
            </section>
      

      <div className="container py-5 mt-3">
        {/* Header */}
        <div className="text-center mb-5 mt-4">
          <h1 className=" fw-bold text-dark mb-3">Capabilities</h1>
          <p className="lead text-dark fw-medium" style={{fontSize:"16px"}}>
            Integrated Manufacturing & Engineering Solutions for Automotive OEMs
          </p>
        </div>

        {/* Grid */}
        <div className="row g-4">
          {capabilities.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="cap-new-card">
                <div className="cap-icon-box">
                  <img src={item.icon} alt={item.title} className="cap-new-icon" />
                </div>
                <div className="cap-content">
                  <h5 className="cap-new-title">{item.title}</h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Capabilities;